import Component from '@glimmer/component';
import { service } from '@ember/service';

export default class ContactItemComponent extends Component {
  @service session;
}
